import { componentsEn } from '@project/components';
export default {
  ...componentsEn,
  "currencyCode": "USD",

  /************************************************************
   * ID360 Components
   * -----------------------------------
   * First section of id corresponds to component using the
   * translation
   ************************************************************/
  "AssetModal.deleteMessage": "Are you sure you want to delete this asset?",
  "AssetModal.warning": "Warning: There are unsaved changes.",

  "AssetSection.noAssets": "No Assets",
  "AssetSection.addAsset": "+ Add {asset}",

  "BasicInfoForm.uploadFloorplanPhotos": "Upload additional floorplan photos",
  "BasicInfoForm.uploadAdditionalPhotos": "Upload additional images",
  "BasicInfoForm.addressLabel": "City/State/Zip",
  "BasicInfoForm.address": "{city}, {state} {postal}",
  "BasicInfoForm.sqftMismatch": "Warning: Greater than 2% mismatch between actual and client provided square footages",
  "BasicInfoForm.defaultPdfStyle.label": "ID360 PDF Template",
  "BasicInfoForm.defaultPdfStyle.placeholder": "Default style",
  "BasicInfoForm.upload.featured": "Featured Image",
  "BasicInfoForm.upload.additionalImages": "Additional Images",
  "BasicInfoForm.upload.floorplans": "Featured Floorplan",
  "BasicInfoForm.upload.additionalFloorplans": "Additional Floorplans",
  "BasicInfoForm.upload.profilePdf": "Profile PDF",
  "BasicInfoForm.upload.lodPdf": "LOD PDF",
  "BasicInfoForm.upload.autocad": "AUTOCAD",
  "BasicInfoForm.uploadFile.error": "There was an error uploading the file(s). Refresh and try again.",
  "BasicInfoForm.deleteFile.error": "There was an error deleting the file(s). Refresh and try again.",

  //ChangeFloorName Component
  "ChangeFloorName.title": "Change Floor Name",

  //CompanyGeneralTab Component
  "CompanyGeneralTab.contactRepresentativeLabel": "Enable Contact Representative Button",
  "CompanyGeneralTab.showCompanyLogoLabel": "Show Company Logo on Profile",
  "CompanyGeneralTab.showCompanyLogoPdfLabel": "Show Company Logo in PDFs",
  "CompanyGeneralTab.disablePublicProfilesLabel": "Disable Public Profiles",
  "CompanyGeneralTab.zipAssetImagesLabel": "Build Zip with Asset Images",
  "CompanyGeneralTab.description": "Configure settings for this company.",
  "CompanyGeneralTab.saveButton": "Save Settings",
  "CompanyGeneralTab.title": "Settings",
  "CompanyGeneralTab.defaultPdfStyle.label": "Choose the default style for ID360 PDFs",
  "CompanyGeneralTab.defaultPdfStyle.placeholder": "Default style",

  //CompanyIntegrationsTabs Component
  "CompanyIntegrationsTabs.bearerToken": "Bearer Token?",
  "CompanyIntegrationsTabs.authRequired": "Authentication Required?",
  "CompanyIntegrationsTabs.enablePublish": "Enable Publish Notifications",
  "CompanyIntegrationsTabs.title": "Publish Notifications",
  "CompanyIntegrationsTabs.saveButton": "Save Integration Settings",
  "CompanyIntegrationsTabs.description": "Configure integration settings for this company.",
  "CompanyIntegrationsTabs.authUsername": "Auth Username",
  "CompanyIntegrationsTabs.authPassword": "Auth Password",
  "CompanyIntegrationsTabs.authEndpoint": "Auth Endpoint",
  "CompanyIntegrationsTabs.authTokenKey": "Auth Token Key",
  "CompanyIntegrationsTabs.authHeaderKey": "Auth Header Key",
  "CompanyIntegrationsTabs.endpoint": "Endpoint",
  "CompanyIntegrationsTabs.headers": "Headers",
  "CompanyIntegrationsTabs.payload": "Payload",
  "CompanyIntegrationsTabs.authClientID": "Auth Client ID",
  "CompanyIntegrationsTabs.authClientSecret": "Auth Client Secret",
  "CompanyIntegrationsTabs.authScope": "Auth Client Auth Scope",
  "CompanyIntegrationsTabs.payloadFormat.label": "Payload Format",
  "CompanyIntegrationsTabs.payloadFormat.placeholder": "Select Format",
  "CompanyIntegrationsTabs.authType.label": "Authentication Type",
  "CompanyIntegrationsTabs.authType.placeholder": "Select Type",

  //CompanySettings Component
  "CompanySettings.pageTitle": "Company Settings - Admin - ID360",
  "CompanySettings.title": "Company Settings",
  "CompanySettings.saveSuccessful": "Company settings saved successfully",

  //CompanySettingsTabs Component
  "CompanySettingsTabs.title": "General Settings",
  "CompanySettingsTabs.fieldSettings.tabTitle": "Field Settings",
  "CompanySettingsTabs.fieldSettings.description": "Toggle off fields that should not appear for this company",
  "CompanySettingsTabs.fieldSettings.saveButton": "Save Field Settings",
  "CompanySettingsTabs.fieldSettings.basicInfoTitle": "Basic Info",
  "CompanySettingsTabs.integrations.tabTitle": "Integrations",
  "CompanySettingsTabs.visible": "Publicly Visible",
  "CompanySettingsTabs.required": "Required",
  "CompanySettingsTabs.softRequired": "Soft Required",
  "CompanySettingsTabs.enabled": "Enabled",
  "CompanySettingsTabs.notSurveyed": "Allow Survey Bypass",
  "CompanySettingsTabs.showAssets": "Show {type} Assets",

  //CreateNewProfile Component
  "CreateNewProfile.title": "Create new profile",
  "CreateNewProfile.subtitle": "Create Profile",
  "CreateNewProfile.addressNotFound": "Address not detected, please correct in admin",
  "CreateNewProfile.createProfile.button": "Create Profile",
  "CreateNewProfile.editProfile": "Edit Profile",
  "CreateNewProfile.hasProfile": "Has ID360 Profile",
  "CreateNewProfile.idpRecord.details": "These options come from CRM; if you don't see the ID360 Record ID, please contact support.",
  "CreateNewProfile.idpRecord.required": "ID360 Record ID is required.",
  "CreateNewProfile.selectIdpRecord": "Select an IDP Record...",
  "CreateNewProfile.idpRecord.other": "Other (enter manually)",
  "CreateNewProfile.enterIdpRecord": "Enter IDP Record ID" ,

  //Layout Component
  "Layout.createNewProfile": "Create New Profile",
  "Layout.recent": "Recent",
  "Layout.companySettings": "Company Settings",

  // SurveyableField Component
  "SurveyableField.notSurveyed": "Not Surveyed",
  "SurveyableField.notSurveyedReason": "Reason",
  "SurveyableField.notSurveyedReason.placeholder": "Select Reason",
  "SurveyableField.notSurveyedReason.other": "Other",
  "SurveyableField.notSurveyedReason.other.required": "Please specify a reason",
  "SurveyableField.notSurveyedOption.construction": "Construction Onsite w/No Access",
  "SurveyableField.notSurveyedOption.notProvided": "RSF Not Provided on Site Plan",
  "SurveyableField.notSurveyedOption.permanentCeiling": "Drywall Ceiling in the Space",
  "SurveyableField.notSurveyedOption.insulation": "Heavy Insulation in the Ceiling",
  "SurveyableField.notSurveyedOption.equipmentIssues": "Equipment Issues",
  "SurveyableField.notSurveyedOption.noAccess": "Wall is Inaccessible",
  "SurveyableField.notSurveyedOption.notPresent": "Wall Not Present in the Space",
  "SurveyableField.notSurveyedOption.notPartOfScope": "Not Part of Scope",
  "SurveyableField.notSurveyedOption.safety": "Safety Concerns - See Notes",
  "SurveyableField.notSurveyedOption.weather": "Poor Weather at the Time of Survey",
  "SurveyableField.notSurveyedOption.tenantDenied": "Tenant Denied Access",
  "SurveyableField.notSurveyedOption.lockboxIssues": "Locked w/No Access",
  "SurveyableField.notSurveyedOption.physicallyInaccessibleObstructions": "Physically Inaccessible Due to Obstructions",
  "SurveyableField.notSurveyedOption.ceilingNotPresent": "Ceiling Not Present in the Space",
  "SurveyableField.notSurveyedOption.joistNotPresent": "Joist Not Present in the Space",
  "SurveyableField.notSurveyedOption.deckNotPresent": "Deck Not Present in the Space",
  "SurveyableField.notSurveyedOption.girderNotPresent": "Girder Not Present in the Space",
  "SurveyableField.notSurveyedOption.columnNotPresent": "Columns Not Present in the Space",
  "SurveyableField.notSurveyedOption.speedBayNotPresent": "Speed Bay Not Present in the Space",
  "SurveyableField.notSurveyedOption.truckApronNotPresent": "Truck Apron Not Present for the Space",
  "SurveyableField.notSurveyedOption.truckCourtNotPresent": "Truck Court Not Present for the Space",
  "SurveyableField.notSurveyedOption.lockboxNotPresent": "Lockbox Not Present",
  "SurveyableField.notSurveyedOption.assetNotPresent": "Asset Is Not Present For the Space",
  "SurveyableField.notSurveyedOption.lockboxJammed": "Lockbox Jammed",
  "SurveyableField.notSurveyedOption.lockboxWrongKey": "Lockbox Has Wrong Key",
  "SurveyableField.notSurveyedOption.lockboxNoKey": "Lockbox Has No Key",
  "SurveyableField.notSurveyedOption.emergencyReasons": "Emergency Reasons",
  "SurveyableField.notSurveyedOption.revisitRequired": "Revisit Required",

  //ProfileAssetSection Component
  "ProfileAssetSection.noData": "No data available.",

  //ProfileFloors Component
  "ProfileFloors.addNewLevel.details": "This will add a new level to the current space profile.",
  "ProfileFloors.addNewLevel.title": "Add New Level",
  "ProfileFloors.addNewLevel.confirm": "Add Level",
  "ProfileFloors.addNewLevel.error": "Cannot add a new level when there are errors on the current level.",
  "ProfileFloors.removeLevel.details": "Please confirm that you would like to delete {level}. This cannot be undone.",
  "ProfileFloors.removeLevel.title": "Remove Level",
  "ProfileFloors.removeLevel.confirm": "Delete Level",

  //ProfileImageUpload Component
  "ProfileImageUpload.upload": "Upload {item}",
  "ProfileImageUpload.photos": "Photos",
  "ProfileImageUpload.floorplans": "Floorplans",

  //ProfilePublishButton Component
  "ProfilePublishButton.publish.dropdownTitle": "Publish",
  "ProfilePublishButton.publish": "Publish",
  "ProfilePublishButton.publishPreview": "Preview",
  "ProfilePublishButton.publishStatus": "Status",
  "ProfilePublishButton.publishStatus.modalTitle": "Space Profile Status",
  "ProfilePublishButton.publish.modalTitle": "Publish Space Profile",
  "ProfilePublishButton.unpublish": "Unpublish Profile",
  "ProfilePublishButton.tooltip": "Admin access required to unpublish profile",
  "ProfilePublishButton.unpublish.confirmLabel": "Unpublish Space Profile",
  "ProfilePublishButton.unpublish.confirmModal": "This will result in the space profile becoming inactive and no longer publically viewable.",
  "ProfilePublishButton.publishModal.confirmMessage": "This will result in the space profile being publically viewable.",
  "ProfilePublishButton.softRequired": "All required fields for this project have not been completed, do you want to continue?",
  "ProfilePublishButton.previewModal.confirmMessage": "Space profile currently contains no errors and is ready to publish.",
  "ProfilePublishButton.previewModal.errorsFound": "Space profile currently contains errors at:",

  //PropertySelect Component
  "PropertySelect.selectProperty": "Select Property",

  //ProfileShare Component
  "ProfileShare.share": "Share",
  "ProfileShare.shareProfile": "Share this profile",
  "ProfileShare.body": "Please take a look at this ID360 Space Profile:%0D%0A{url}",
  "ProfileShare.subject": "{property} - Unit {address2}",

  //ProfileStatus Component
  "ProfileStatus.status": "Status",
  "ProfileStatus.historyMessage": "{altered} by {user} on {date} at {time}",
  "ProfileStatus.preview": "Preview available to other ID360 users at",
  "ProfileStatus.availablAt": "Available at",
  "ProfileStatus.viewProfilePdf": "View Profile PDF",
  "ProfileStatus.viewAdaPdf": "View ADA PDF",
  "ProfileStatus.privateLink": "Private link",
  "ProfileStatus.view": "View",
  "ProfileStatus.zippedAssetImages": "Asset Images",
  "ProfileStatus.generateZippedAssetImages": "Generate Images Zip",
  "ProfileStatus.generateZippImageMessage": "Zip file is generating. Please refresh the page in a few minutes.",

  //RecentProfiles Component
  "RecentProfiles.pageTitle": "Recent Profiles - Admin - ID360",
  "RecentProfiles.title": "Recent",
  "RecentProfiles.searchFilter": "Search Filter",
  "RecentProfiles.searchNoMatches": "No profiles match the search.",
  "RecentProfiles.address": "{address1}, Unit {address2}, {city}",
  "RecentProfiles.publish.label": "Status: ''",

  //Settings Component
  "Settings.pageTitle": "Settings - Admin - ID360",
  "Settings.title": "Settings",
  "Settings.name": "Name",
  "Settings.email": "Email",
  "Settings.password": "Password",
  "Settings.changeName": "Change Name",
  "Settings.changeEmail": "Change Email",

  //SpaceProfile Component
  "SpaceProfile.title": "Create new profile",
  "SpaceProfile.basicInfo": "Basic Info",
  "SpaceProfile.modal.timeoutModalHeader": "Message from ID360",
  "SpaceProfile.modal.timeoutModalText": "Idle timeout reached. Page reload necessary.",
  "SpaceProfile.modal.timeoutmodalReload": "Reload!",
  "SpaceProfile.alerts.noAssetGuid": "Error: Unit (Space Asset) not found. Please contact admin.",

  //SpaceSelect Component
  "SpaceSelect.placeholder": "Select Space",

  //ViewProfile Component
  "ViewProfile.contact": "Contact Representative",
  "ViewProfile.dataPoints": "{dataPoints, plural, =0 {# data points} one {# data point} other {# data points}} on this space",
  "ViewProfile.address1": "{address}, {city}, {state}, {postal}",
  "ViewProfile.address2": "Unit {address2}",
  "ViewProfile.width": "width",
  "ViewProfile.depth": "depth",
  "ViewProfile.pageTitle": "{name} - Unit {address2} - ID360",
  "ViewProfile.description": "{name} - Unit {address2} - ID360 Space Profile",
  "ViewProfile.assetManager": "Asset Manager",
  "ViewProfile.leasingRepresentative": "Leasing Representative",
  "ViewProfile.propertyManager": "Property Manager",
  "ViewProfile.billingSpecialist": "Billing Specialist",
  "ViewProfile.renewalAgent": "Renewal Agent",
  "ViewProfile.propertyManagerAssistant": "Property Manager Assistant",
  "ViewProfile.leasingAgent": "Leasing Agent",
  "ViewProfile.constructionManager": "Construction Manager",

  /************************************************************
   * Asset Schema
   * -----------------------------------
   * Translations for the asset schema file which is used
   * throughtout the application
   ************************************************************/

  //AssetSchema
  "assetSchema.headers.thickness": "Thickness",
  "assetSchema.headers.unit_overview": "Unit Overview",
  "assetSchema.headers.flooring": "Flooring",
  "assetSchema.headers.ceiling_information": "Ceiling Information",
  "assetSchema.headers.outer_unit_corner_to_outer_block_corner": "Corner to Corner Building Lengths",
  "assetSchema.headers.height_from_floor_to_bottom_of_girder_kite": "Height From Floor to Bottom of Girder (Special Scope)",
  "assetSchema.headers.construction_overview": "Construction Overview",
  "assetSchema.headers.property_features": "Property Features",
  "assetSchema.headers.other": "Other",
  "assetSchema.headers.integrations": "Integrations",
  "assetSchema.headers.space_overview": "Space Overview",
  "assetSchema.headers.floorplan": "Floorplan",
  "assetSchema.headers.floorplans": "Floorplans",
  "assetSchema.headers.overview": "Overview",
  "assetSchema.headers.interior_dock_leveler_type": "Interior Dock Leveler Type ",
  "assetSchema.headers.interior_dock_leveler_width": "Interior Dock Leveler Width",
  "assetSchema.headers.interior_dock_leveler_height": "Interior Dock Leveler Height",
  "assetSchema.headers.dock_leveler_length": "Interior Dock Leveler Length",
  "assetSchema.headers.mechanical": "Mechanical",
  "assetSchema.headers.hydraulic": "Hydraulic",
  "assetSchema.headers.storefront_width": "Storefront Width (includes avg. wall thickness)",
  "assetSchema.headers.storefront_features": "Storefront Features",
  "assetSchema.headers.damaged_stained_missing_acoustical_tiles": "Number of Damaged, Stained, or Missing Acoustical Tiles",
  "assetSchema.headers.ceiling_types": "Select the ceiling types present inside the space",
  "assetSchema.headers.wall_types": "Select the wall types present inside the space",
  "assetSchema.headers.exterior_door_count": "Exterior Door Count",
  "assetSchema.headers.exterior_door_dimensions": "Exterior Door Dimensions (3'0”W x 7'0”H)",
  "assetSchema.headers.exterior_door_locations": "Exterior Door Locations",
  "assetSchema.headers.light_fixture_count": "Light Fixture Count",
  "assetSchema.headers.type_of_lighting": "Type of Lighting",
  "assetSchema.headers.type_of_fixture": "Type of Fixture",

  "assetSchema.options.encased": "Encased",
  "assetSchema.options.suspended": "Suspended",
  "assetSchema.options.recessed": "Recessed",
  "assetSchema.options.flush_mount": "Flush Mount",
  "assetSchema.options.track": "Track",
  "assetSchema.options.sconce": "Sconce",
  "assetSchema.options.strip": "Strip",
  "assetSchema.options.flourescent": "Flourescent",
  "assetSchema.options.led": "LED",
  "assetSchema.options.halogen": "Halogen",
  "assetSchema.options.metal_hallide": "Metal Hallide",
  "assetSchema.options.hps": "HPS (High Pressure Sodium)",
  "assetSchema.options.incandescent": "Incandescent",
  "assetSchema.options.NA": "NA",
  "assetSchema.glass": "Glass",
  "assetSchema.stone": "Stone",
  "assetSchema.concrete_type": "Concrete",
  "assetSchema.vinyl": "Vinyl",
  "assetSchema.pvc": "PVC",
  "assetSchema.tile_type": "Tile",
  "assetSchema.brick": "Brick",
  "assetSchema.fiber_reinforced_plastic": "Fiber Reinforced Plastic",
  "assetSchema.open_stud": "Open Stud",
  "assetSchema.open_ceiling": "Open Ceiling",
  "assetSchema.acoustic_tile": "Acoustic Tile",
  "assetSchema.drywall": "Drywall",
  "assetSchema.wood": "Wood",
  "assetSchema.metal": "Metal",
  "assetSchema.concrete_ceiling_type": "Concrete",
  "assetSchema.stucco": "Stucco",
  "assetSchema.inconclusive": "Inconclusive",
  "assetSchema.inaccessible": "Inaccessible",
  "assetSchema.walkway": "Walkway",
  "assetSchema.trash_cans": "Trash Can(s)",
  "assetSchema.ash_trays": "Ash Tray(s)",
  "assetSchema.handicap_parking": "Handicap Parking",
  "assetSchema.columns": "Column(s)",
  "assetSchema.crosswalk": "Crosswalk",
  "assetSchema.canopy": "Canopy",
  "assetSchema.trees": "Tree(s)",
  "assetSchema.bushes": "Bushes",
  "assetSchema.steps": "Step(s)",
  "assetSchema.ramps": "Ramp(s)",
  "assetSchema.handicap_signs": "Handicap Sign(s)",
  "assetSchema.stop_signs": "Stop Sign(s)",
  "assetSchema.tenant_signs": "Tenant Sign(s)",
  "assetSchema.other_affixed_signage": "Other Affixed Signage",
  "assetSchema.railings": "Railing(s)",
  "assetSchema.bollards": "Bollard(s)",
  "assetSchema.grass": "Grass",
  "assetSchema.garden": "Garden",
  "assetSchema.fire_hydrant": "Fire Hydrant",
  "assetSchema.planters": "Planters",
  "assetSchema.dirt": "Dirt",
  "assetSchema.other": "Other",
  "assetSchema.not_available": "N/A",

  "assetSchema.separate_rpm_renders.label": "Split RPM sitemap into multiple sections?",
  "assetSchema.joist_direction.label": "Joist Direction",
  "assetSchema.joist_direction.placeholder": "Select",
  "assetSchema.joist_direction.front_to_back": "Front to Back",
  "assetSchema.joist_direction.left_to_right": "Left to Right",
  "assetSchema.joist_direction.other": "Other Direction - See Floor Plan",
  "assetSchema.virtual_tour_link.label": "Virtual Tour Link",
  "assetSchema.virtual_tour_link.placeholder": "i.e. westshore.ispy-360.com",
  "assetSchema.white_box_link.label": "White Box Link",
  "assetSchema.white_box_link.placeholder": "i.e. panoviewer.ml3ds-icon.com",
  "assetSchema.actual_sq_ft.label": "Actual Square Footage (BOMA)",
  "assetSchema.overall_actual_sq_ft.label": "Overall Actual Square Footage (All Levels)",
  "assetSchema.actual_sq_ft.publicLabel": "Actual Square Footage",
  "assetSchema.actual_sq_ft.placeholder": "Measured sqft",
  "assetSchema.overall_actual_sq_ft.publicLabel": "Overall Actual Sq Footage",
  "assetSchema.overall_actual_sq_ft.placeholder": "Multi-Floor Units Only",
  "assetSchema.client_provided_sq_ft.label": "Client Provided Square Footage",
  "assetSchema.client_provided_sq_ft.placeholder": "Provided sqft",
  "assetSchema.has_stepdown_transformer.label": "Is there a step-down transformer present?",
  "assetSchema.tear_sheet.label": "Tear Sheet",
  "assetSchema.size.label": "Non-Warehouse Sq Ft",
  "assetSchema.office_area": "Non-Warehouse Sq Ft %",
  "assetSchema.mezannine_area": "Mezzanine Area (Sq Ft)",
  "assetSchema.year_built": "Year Built",
  "assetSchema.site_size.label": "Site Size (Total Acreage)",
  "assetSchema.tax_pin.label": "Tax Pin (Parcel ID Number)",
  "assetSchema.zoning": "Zoning (Designation)",
  "assetSchema.measured_width_of_space.label": "Measured Width of Space",
  "assetSchema.measured_width_of_space.placeholder": "Exterior front to exterior back",
  "assetSchema.measured_depth_of_space.label": "Measured Depth of Space",
  "assetSchema.measured_depth_of_space.placeholder": "Exterior front to exterior back",
  "assetSchema.total_depth_of_space.label": "Magicplan Depth of Space",
  "assetSchema.total_depth_of_space.publicLabel": "Total Depth of Space",
  "assetSchema.total_depth_of_space.placeholder": "Exterior front to exterior back",
  "assetSchema.changes_in_demising_wall_thickness.label": "Are there changes in the demising wall thickness?",
  "assetSchema.which_demising_wall_changes.label": "Which Demising Wall(s) have Changes in Thickness?",
  "assetSchema.which_demising_wall_changes.placeholder": "Rear, Right",
  "assetSchema.difference_demising_wall_thickness.label": "What is the Difference in Demising Wall Thickness(s)? (inches)",
  "assetSchema.difference_demising_wall_thickness.placeholder": "3\"",
  "assetSchema.hazardous_materials.label": "Are there hazardous materials present?",
  "assetSchema.loading_dock.label": "Is there a loading dock on the premises?",
  "assetSchema.left": "Left",
  "assetSchema.right": "Right",
  "assetSchema.left_or_front": "Left or Front",
  "assetSchema.right_or_rear": "Right or Rear",
  "assetSchema.left_front": "Left Front",
  "assetSchema.left_rear": "Left Rear",
  "assetSchema.right_rear": "Right Rear",
  "assetSchema.right_front": "Right Front",
  "assetSchema.middle": "Middle",
  "assetSchema.rear": "Rear",
  "assetSchema.all_sides": "All Sides",
  "assetSchema.thickness.front_wall": "Front Wall",
  "assetSchema.thickness.rear_wall": "Rear Wall",
  "assetSchema.thickness.left_wall": "Left Wall",
  "assetSchema.thickness.right_wall": "Right Wall",
  "assetSchema.thickness.other": "Other",
  "assetSchema.sales_area": "Sales Area",
  "assetSchema.stock_room": "Stock Room",
  "assetSchema.exterior_doors": "Exterior Doors",
  "assetSchema.unit_overview.other": "Other",
  "assetSchema.concrete": "Concrete Sq. Ft.",
  "assetSchema.tile": "Tile Sq. Ft.",
  "assetSchema.flooring.other": "Other Sq. Ft.",
  "assetSchema.carpet": "Carpet Sq. Ft.",
  "assetSchema.flooring.total.label": "Total Unit Sq. Ft. Without Walls",
  "assetSchema.flooring.total.publicLabel": "Total Sq. Ft.",
  "assetSchema.flooring.unit.label": "Total Unit Sq. Ft. With Walls",
  "assetSchema.flooring.unit.publicLabel": "Unit Sq. Ft.",
  "assetSchema.flooring.type_of_other.label": "Type of Other",
  "assetSchema.flooring.type_of_other.placeholder": "Linoleum",
  "assetSchema.front": "Front",
  "assetSchema.left_side": "Left Side",
  "assetSchema.right_side": "Right Side",
  "assetSchema.back": "Back",
  "assetSchema.center": "Center",
  "assetSchema.height_from_floor_to_bottom_of_girder": "Height from Floor to Bottom of Girder",
  "assetSchema.clear_ceiling_height": "Clear Ceiling Height",
  "assetSchema.number_of_acoustical_tiles": "Number of Acoustical Tiles",
  "assetSchema.structure.label": "Structure",
  "assetSchema.structure.placeholder": "Tilt-Up Precast Concrete",
  "assetSchema.roof.label": "Roof Type",
  "assetSchema.roof.placeholder": "Single-Ply EPDM Membrane with Gravel Ballast",
  "assetSchema.roof_warranty_expiration.label": "Roof Warranty Expiration",
  "assetSchema.sprinkler_head_type.label": "Sprinkler Head Type",
  "assetSchema.sprinkler_system.label": "Sprinkler System / ESFR",
  "assetSchema.warehouse_sprinkler_head_type.label": "Warehouse Sprinkler Head Type",
  "assetSchema.office_sprinkler_head_type.label": "Non-Warehouse Sprinkler Head Type",
  "assetSchema.office_lighting_type.label": "Non-Warehouse Lighting Type (Bulb Type)",
  "assetSchema.sprinkler_system.placeholder": "Wet / No",
  "assetSchema.warehouse_lighting_type.label": "Warehouse Lighting Type (Bulb Type)",
  "assetSchema.warehouse_lighting_type.placeholder": "T5",
  "assetSchema.exterior_wall_photograph.label": "Does the back of the space have an exterior wall to photograph?",
  "assetSchema.storefront_scan_width.label": "Does the storefront photo and scan show the entire width of the space?",
  "assetSchema.roof_capture_hvac.label": "Is there a roof capture within 10' of each HVAC unit for the space?",
  "assetSchema.roof_plan_complete.label": "Does the space have a roof directly above it and is the roof plan complete?",
  "assetSchema.projector_photograph.label": "Is there a projector in the space that has been photographed?",
  "assetSchema.window_pane_type.label": "Are the windows single pane or insulated?",
  "assetSchema.window_pane_type.placeholder": "Double Pane, Single Pane",
  "assetSchema.single_pane": "Single Pane",
  "assetSchema.double_pane": "Double Pane",
  "assetSchema.triple_pane": "Triple Pane",
  "assetSchema.access_interior_area.label": "Is the space accessed from an interior shared area?",
  "assetSchema.floor_drain_count.label": "Floor Drain Count",
  "assetSchema.floor_drain_location.label": "Floor Drain Location",
  "assetSchema.phone_board_count.label": "Phone Board Count",
  "assetSchema.thermostat_count.label": "Thermostat Count",
  "assetSchema.cleanout_count.label": "Cleanout Count",
  "assetSchema.cleanout_location.label": "Cleanout Location",
  "assetSchema.pad_mounted_transformer_count.label": "Pad Mounted Transformer Count",
  "assetSchema.pad_mounted_transformer_location.label": "Pad Mounted Transformer Location",
  "assetSchema.exterior_transformer.label": "Is there an exterior transformer present?",
  "assetSchema.meter_room_space.label": "Are any meters in the space located in a meter room?",
  "assetSchema.exterior_access_rooms.label": "Are there any rooms accessed from the exterior that are within the footprint of the space?",
  "assetSchema.exterior_partition_extrusion.label": "Are there exterior wall additions, such as partitions or wall extrusions, that add thickness to the exterior walls?",
  "assetSchema.hydraulic_sprinkler.label": "Is there a Hydraulic Sprinkler System plate photographed?",
  "assetSchema.clear_height": "Clear Height (Floor to Joist)",
  "assetSchema.building_dimensions": "Building Dimensions",
  "assetSchema.space_dimensions_width": "Space Dimensions (Width)",
  "assetSchema.space_dimensions_length": "Space Dimensions (Length)",
  "assetSchema.space_dimensions": "Space Dimensions",
  "assetSchema.column_bay_spacing": "Column Bay Spacing (Width)",
  "assetSchema.column_bay_spacing_depth": "Column Bay Spacing (Depth)",
  "assetSchema.speed_bays": "Speed Bays (Depth)",
  "assetSchema.truck_court_depth": "Truck Court Depth (Length)",
  "assetSchema.truck_apron": "Truck Apron",
  "assetSchema.loading.label": "Loading (Type)",
  "assetSchema.loading.placeholder": "Front Load / Rear Load / Crossdock",
  "assetSchema.floor_load": "Floor Load (lbs per Sq Ft)",
  "assetSchema.num_of_trailer_parking_spots": "# of Trailer Parking Spots",
  "assetSchema.dock_doors": "Dock Doors",
  "assetSchema.drive_in_doors": "Drive-In Doors",
  "assetSchema.railway_dock_doors": "Railway Dock Door Count",
  "assetSchema.car_parking": "Car Parking",
  "assetSchema.hvac": "HVAC (# of HVAC Units)",
  "assetSchema.utility_submetered": "Utility Submetered (Yes/No)",
  "assetSchema.power.label": "Power Information",
  "assetSchema.power.placeholder": "400-Amp, 277/480 Volt, 3-Phase, 4-Wire",
  "assetSchema.electric_meter_distance": "Electric Meter Distance from Unit in full feet?",
  "assetSchema.gas_meter_distance": "Gas Meter Distance from Unit in full feet?",
  "assetSchema.water_meter_distance": "Water Meter Distance from Unit in full feet?",
  "assetSchema.transformer_distance": "Pad Mounted Transformer Distance from Unit in full feet?",
  "assetSchema.sewer_cleanout_distance": "Sewer Cleanout Distance from Unit in full feet?",
  "assetSchema.utility_room_distance": "Utility Room Distance from Unit in full feet?",
  "assetSchema.DMARC_distance": "DMARC Distance from Unit in full feet?",
  "assetSchema.phone_board_location": "Phone Board Location",
  "assetSchema.mop_sink_location": "Mop Sink Location",
  "assetSchema.mop_sink_count": "Mop Sink Count",
  "assetSchema.sanitary_sewer_location": "Sanitary Sewer Location",
  "assetSchema.sanitary_sewer_count": "Sanitary Sewer Count",
  "assetSchema.thermostat_location.label": "Thermostat Location",
  "assetSchema.cooler_manufacturer": "Cooler Manufacturer",
  "assetSchema.storefront_slope_measurement.label": "Storefront Slope Measurement",
  "assetSchema.storefront_slope_measurement.placeholder": "Total Width of Storefront",
  "assetSchema.storefront_slope_direction.label": "Storefront Slope Direction",
  "assetSchema.storefront_slope_direction.placeholder": "Right",
  "assetSchema.riser_room_scanned_captured.label": "Riser Room Scanned/Captured",
  "assetSchema.are_demising_walls_full_height": "Are demising walls full height to deck?",
  "assetSchema.are_interior_walls_full_height": "Are interior walls full height to deck?",
  "assetSchema.lockbox_used_to_access_the_space": "Lockbox Used to Access the Space?",
  "assetSchema.exterior_ladder_used_to_access_the_roof": "Exterior Ladder Used to Access the Roof?",
  "assetSchema.roof_too_unsafe_to_access": "Roof Too Unsafe to Access?",
  "assetSchema.roof_hatch_used_to_access_the_roof": "Roof Hatch Used to Access the Roof?",
  "assetSchema.misc_notes.label": "Miscellaneous Notes",
  "assetSchema.misc_notes.placeholder": "Notes",
  "assetSchema.integrations": "Integration Property ID",
  "assetSchema.integrations.idp_record_id": "ID360 Record ID",
  "assetSchema.flooring_square_footage": "Flooring Square Footage",
  "assetSchema.height_from_floor_to_ceiling": "Height from Floor to Ceiling",
  "assetSchema.height_from_floor_to_bottom_of_deck": "Height from Floor to Bottom of Deck",
  "assetSchema.height_from_floor_to_bottom_of_joist": "Height from Floor to Bottom of Joist",
  "assetSchema.clear_height_floor_to_deck": "Clear Height (Floor to Deck)",
  "assetSchema.clear_height_floor_to_lowest_obstruction": "Clear Height (Floor to Lowest Immovable Obstruction)",
  "assetSchema.clear_height_floor_front_column": "Clear Height (At Front Column)",
  "assetSchema.clear_height_floor_mid_column": "Clear Height (At Mid Column)",
  "assetSchema.clear_height_floor_rear_column": "Clear Height (At Rear Column)",
  "assetSchema.section.mechanical": "HVAC",
  "assetSchema.section.electrical": "Electric",
  "assetSchema.section.plumbing": "Water",
  "assetSchema.section.waste": "Dumpster",
  "assetSchema.section.fire": "Fire",
  "assetSchema.section.gas": "Gas",
  "assetSchema.section.room": "ADA",
  "assetSchema.section.window": "Window Plans",
  "assetSchema.section.reflective": "Reflected Ceiling Plans",
  "assetSchema.section.storefronts": "Storefronts",

  /************************************************************
   * General Use
   * -----------------------------------
   * General use translations that are used throughout the
   * application in multiple components
   ************************************************************/

  //Error Message
  "error.general": "An error occurred",
  "error.server": "The server is not responding",
  "error.spaceProfile.create": "There was an error creating the space profile",
  "error.deleteFile": "There was an error deleting the file",
  "error.iconNotFound": "Upload icon {icon} not found. Using default icon.",
  "error": "Error",
  "error.required": "{field} is required",
  "error.valid": "Enter a valid value for {field}",
  "error.addNewLevel": "There was an error adding a new level",
  "error.deleteNewLevel": "There was an error deleting the level",
  "error.notAvailable": "Not Available",

  //Files
  "file.floorplan": "Floorplan",
  "file.featured": "Featured Image",
  "file.autocad": "AUTOCAD",
  "file.pdf": "LOD PDF",
  "file.profile_pdf": "Profile PDF",
  "file.internal_files": "Internal Files",

  //Floor Labels
  "floorLabels.basement1": "Basement 1",
  "floorLabels.basement2": "Basement 2",
  "floorLabels.groundFloor": "Ground Floor",
  "floorLabels.mainFloor": "Main Floor",
  "floorLabels.mezzanine": "Mezzanine",
  "floorLabels.level": "Level {level}",
  "floorLabels.selector": "Floor Selector",

  //Platform Related Language
  "platform.roles.admin": "Admin",

  // Business or general use terms that are often repeated as content for button
  "term.company": "Company",
  "term.property": "Property",
  "term.unavailable": "Unavailable",
  "term.available": "Available",
  "term.visible": "Visible",
  "term.required": "Required",
  "term.enabled": "Enabled",
  "term.unit": "Unit",
  "term.unit_no": "Unit #",
  "term.address": "Address",
  "term.unknown": "Unknown",
  "term.search": "Search",
  "term.assetType": "Asset Type",
  "term.floorplan": "Floorplan",
  "term.asset": "Asset",
  "term.published": "published",
  "term.unpublished": "unpublished",
  "term.draft": "draft",
  "term.other": "Other",

  //UI elements (common UI buttons, interactions)
  "ui.saving": "Saving",
  "ui.saved": "Save Complete",
  "ui.loading": "Loading",
  "ui.errorSaving": "Error Saving",
  "ui.addressDisplay": "{address}, {city}, {stateOrRegion} {postal}",
  "ui.logout": "Log Out",
  "ui.uploadItem": "Upload {item}",
  "ui.uploading": "Uploading",
  "ui.default": "Default",
  "ui.theme": "Theme",
  "ui.themeTemplate": "{name} Theme",
  "ui.goBack": "Go Back",
  "ui.close": "Close",
  "ui.delete": "Delete",
  "ui.cancel": "Cancel",
  "ui.deleting": "Deleting",
  "ui.save": "Save",
  "ui.details": "Details",
  "ui.uploads": "Uploads",
  "ui.photos": "Photos",
  "ui.images": "Images",
  "ui.reference": "Reference",
  "ui.unitNo": "{unit} #",
  "ui.select": "Select",
  "ui.ok": "OK",
  "ui.yes": "Yes",
  "ui.no": "No",
  "ui.areYouSure": "Are you sure?",
  "ui.name": "Name",
  "ui.size": "Size",
  "ui.uploadDate": "Upload date",
  "ui.uploadedBy": "Uploaded by",
  "ui.uploadAFile": "Upload a file",
  "ui.fileManager": "File Manager",

  // Measurement Units
  "unit.squareFootage": "sqft",
  "unit.squareMeters": "sq m",
  "unit.feet": "feet",
  "unit.inches": "inches",
  /************************************************************
   * Monorepo Components
   * -----------------------------------
   * Translations need to be passed in props as these components
   * don't have access to the intl provider
   ************************************************************/

  //AdminInput Component
  "AdminInput.validationMessage": "Enter a valid value for ''{label}''",

  //AdminModal Component
  "AdminModal.deleteMessage": "Are you sure you want to do this?",
  "AdminModal.yesDelete": "Yes, Delete",

  //ColorPicker Component
  "ColorPicker.chooseHex": "Choose HEX#",
  "ColorPicker.hex": "HEX#",
  "ColorPicker.opacity": "Opacity",

  //Contact Component
  "Contact.phone": "E",
  "Contact.email": "P",
  "Contact.propertyContact": "Property Contact",
  "Contact.assetManager": "Asset Manager",
  "Contact.leasingRepresentative": "Leasing Representative",
  "Contact.propertyManager": "Property Manager",
  "Contact.billingSpecialist": "Billing Specialist",
  "Contact.renewalAgent": "Renewal Agent",
  "Contact.propertyManagerAssistant": "Property Manager Assistant",
  "Contact.leasingAgent": "Leasing Agent",
  "Contact.constructionManager": "Construction Manager",

  //CompanySelectComponent
  "CompanySelect.placeholder": "Select...",
  "CompanySelect.loadingMessage": "Loading...",
  "CompanySelect.noOptions": "No Options",

  //Common Components
  "MapView.noResults": "No results found!"
}
